import { Consumption } from '../model/consumption.model'

import {
  isUnlimitedVoiceTariff,
  isUnlimitedDataTariff,
  totalVoiceInTariff,
  totalDataInTariff,
} from '~/bonus/helpers/bonus.helpers'
import { Bonus } from '~/bonus/model/bonus.model'
import { ratioFromTotal } from '~/utils/format.helpers'

export const dataConsumed = (sc: Consumption | undefined) =>
  sc
    ? sc.consumptionTotals
        .filter((elem) => elem.type === 'DATA')
        .reduce((acum, elem) => elem.amount.value + acum, 0)
    : 0

export const voiceConsumed = (sc: Consumption | undefined) =>
  sc
    ? sc.consumptionTotals
        .filter((elem) => elem.type === 'VOICE')
        .reduce((acum, elem) => elem.amount.value + acum, 0)
    : 0

export function remainingSubscriptionData(bonus?: Bonus[], consumption?: Consumption) {
  return Math.max(((bonus ? totalDataInTariff(bonus) : 0) || 0) - dataConsumed(consumption), 0)
}

export function ratioVoiceConsumed(bonus?: Bonus[], consumption?: Consumption) {
  if (isUnlimitedVoiceTariff(bonus) || voiceConsumed(consumption) === 0) {
    return 1
  }
  if (totalVoiceInTariff(bonus) === 0) {
    return 0
  }
  return 1 - ratioFromTotal(voiceConsumed(consumption), totalVoiceInTariff(bonus))
}

export function ratioDataConsumed(bonus?: Bonus[], consumption?: Consumption) {
  if (isUnlimitedDataTariff(bonus) || dataConsumed(consumption) === 0) {
    return 1
  }
  if (totalDataInTariff(bonus) === 0) {
    return 0
  }
  return 1 - ratioFromTotal(dataConsumed(consumption), totalDataInTariff(bonus))
}

export function totalVoiceConsumed(bonus?: Bonus[], consumption?: Consumption) {
  return Math.max((totalVoiceInTariff(bonus) || 0) - voiceConsumed(consumption), 0)
}
